// extracted by mini-css-extract-plugin
export var sbShowMain = "ctaEduWork-module--sb-show-main--HWMDP";
export var wrapper = "ctaEduWork-module--wrapper--38TTU";
export var title = "ctaEduWork-module--title--3e77d";
export var buttons = "ctaEduWork-module--buttons--ByGH5";
export var text = "ctaEduWork-module--text--2E39q";